import { Controller } from "@hotwired/stimulus"

/**
 * Expands a table row's detail row (SMA-106).
 *
 * Goes on the table or the card, not the row, because a <tr> cannot contain the row it reveals.
 * The button names its panel with aria-controls, so this needs no targets and one instance serves
 * every row in the table.
 *
 *   <table data-controller="expandable-row">
 *     <tr><td><button data-action="click->expandable-row#toggle"
 *                     aria-controls="panel-1" aria-expanded="false">…</button></td></tr>
 *     <tr id="panel-1" hidden>…</tr>
 *
 * Not a <details>: it is not permitted content between table rows, and the browser can open one on
 * its own for find-in-page or printing, which would reveal a panel without any code getting a
 * chance to build what is inside it.
 */
export default class extends Controller {
  toggle(event) {
    const button = event.currentTarget
    const panel = document.getElementById(button.getAttribute("aria-controls"))
    if (!panel) return

    const opening = panel.hidden
    panel.hidden = !opening
    button.setAttribute("aria-expanded", String(opening))
    // A drawing in the panel could not measure itself while it was hidden, so tell it to build.
    // Listeners bind this at @window, because the drawing sits inside the panel and a bubbling
    // event would travel away from it. That reaches every panel's drawing, which carries no id
    // filter because it needs none: only the panel just revealed has a box, and having a box is
    // already what the drawing controller tests before it builds.
    if (opening) this.dispatch("expanded")
  }
}
